const Bags = [
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Gaine multi-outils en cuir véritable EDC ceinture boucle taille",
    price: "22.99",
    raw_price: "45",
    currency: "USD",
    discount: "49",
    likes_count: "174",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "café",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/40/E1/ad8b6f95-a182-4b6c-9fbe-e5f9c8dba4e5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/40/E1/ad8b6f95-a182-4b6c-9fbe-e5f9c8dba4e5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/90/D7/f0c21c5f-22de-4443-8576-9be533a9532c.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/90/D7/f0c21c5f-22de-4443-8576-9be533a9532c.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6F/BD/6d143095-4942-4ec1-b4ca-c73522f5e3a1.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1704506.html",
    id: "1704506",
    model: "SKUF57496",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac ceinture EDC Retro en cuir véritable 7,2 pouces",
    price: "23.42",
    raw_price: "41.87",
    currency: "USD",
    discount: "44",
    likes_count: "377",
    is_new: "false",
    brand: "E Ekphero",
    brand_url: "https://fr.newchic.com/e-ekphero-brand-42.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Brown",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AA/66/b4877cef-11a2-43b9-a784-4fc9a08b0870.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AA/66/b4877cef-11a2-43b9-a784-4fc9a08b0870.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A1/C9/b3f0bcfd-5289-48df-9fdb-c15441e1e6de.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A1/C9/b3f0bcfd-5289-48df-9fdb-c15441e1e6de.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C7/71/c5ca782d-5178-4303-908e-cbf855708542.jpeg",
    url: "https://fr.newchic.com/e-ekphero-chic-wallet-3614/p-1644205.html",
    id: "1644205",
    model: "SKUE46942",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Sac de taille de téléphone en cuir véritable de 6,5 pouces pour hommes EDC",
    price: "21.99",
    raw_price: "40",
    currency: "USD",
    discount: "45",
    likes_count: "192",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5A/3D/7ce3a339-af25-4a38-b30d-348f64d3960f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5A/3D/7ce3a339-af25-4a38-b30d-348f64d3960f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D6/B1/b0863245-7f33-4118-b37a-8d2b772a625e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D6/B1/b0863245-7f33-4118-b37a-8d2b772a625e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9D/65/13565348-856d-408e-8eae-3ec4340ac2db.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1689612.html",
    id: "1689612",
    model: "SKUF31609",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "EDC en cuir véritable rétro 6,3 pouces sac de téléphone",
    price: "19.99",
    raw_price: "66.63",
    currency: "USD",
    discount: "70",
    likes_count: "207",
    is_new: "false",
    brand: "E Ekphero",
    brand_url: "https://fr.newchic.com/e-ekphero-brand-42.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/13/67/426f4b5b-6e16-44cd-ba86-6c786de5dd13.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/13/67/426f4b5b-6e16-44cd-ba86-6c786de5dd13.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4E/50/8cf6d597-e70c-4ef8-af2b-14219d72368c.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4E/50/8cf6d597-e70c-4ef8-af2b-14219d72368c.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0B/A6/ffcdc1a3-c544-4045-9d6b-e3289e19a1d2.jpg",
    url: "https://fr.newchic.com/e-ekphero-chic-wallet-3614/p-1676960.html",
    id: "1676960",
    model: "SKUF18782",
  },
  {
    category: "bags",
    subcategory: "Sacs à main",
    name: "Sac à bandoulière en toile imprimé fleur pour femme",
    price: "33.99",
    raw_price: "67",
    currency: "USD",
    discount: "49",
    likes_count: "218",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu",
    variation_1_color: "Bleu foncé",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/92/21/2e21497c-805e-48bd-8f50-1997648f04d5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/92/21/2e21497c-805e-48bd-8f50-1997648f04d5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D4/A2/cf846463-ac20-4daa-9ca3-45ceec752de5.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D4/A2/cf846463-ac20-4daa-9ca3-45ceec752de5.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/02/02c4b6ef-6b54-4706-86b1-8bf6f3810ace.jpg",
    url: "https://fr.newchic.com/handbags-3609/p-1697644.html",
    id: "1697644",
    model: "SKUF51272",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac ceinture rétro en cuir véritable EDC pour hommes",
    price: "22.99",
    raw_price: "49",
    currency: "USD",
    discount: "53",
    likes_count: "66",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F7/B0/24690058-39a7-469f-97f3-9448bac21f0c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F7/B0/24690058-39a7-469f-97f3-9448bac21f0c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/99/CF/ddb9c41e-9da7-4e67-afd4-ee6a95bdd462.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/99/CF/ddb9c41e-9da7-4e67-afd4-ee6a95bdd462.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FD/3B/2fd52c99-efcd-4dd6-a328-1f4471cff1df.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1678760.html",
    id: "1678760",
    model: "SKUF19654",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac ceinture en cuir véritable EDC pour hommes",
    price: "24.99",
    raw_price: "48.99",
    currency: "USD",
    discount: "49",
    likes_count: "90",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Brown",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/20/08/ca404343-957c-4b83-b0fe-bf277dc3ed23.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/20/08/ca404343-957c-4b83-b0fe-bf277dc3ed23.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/73/62/8663bd52-19db-4969-82d0-42d7fc1e1204.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/73/62/8663bd52-19db-4969-82d0-42d7fc1e1204.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AC/22/e6c60d49-197a-43e5-bb99-9d5caad851cc.png",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1689026.html",
    id: "1689026",
    model: "SKUF31716",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "6 emplacements pour cartes 6,3 pouces sac de téléphone ",
    price: "21.79",
    raw_price: "49",
    currency: "USD",
    discount: "56",
    likes_count: "779",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Pink",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/68/39/492e6bc8-521e-487f-b7f6-79096ff54da5.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/68/39/492e6bc8-521e-487f-b7f6-79096ff54da5.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A1/AC/17cc8a75-9901-4001-bde7-5911d3a299e1.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A1/AC/17cc8a75-9901-4001-bde7-5911d3a299e1.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/59/55/8c6ffa80-dafe-4dfa-aba6-26598aa899bc.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1651529.html",
    id: "1651529",
    model: "SKUE73992",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Hommes EDC Multitool Flashlight Key Belt Bag",
    price: "21.99",
    raw_price: "45",
    currency: "USD",
    discount: "51",
    likes_count: "54",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Brown",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/05/01/41040c70-d248-43a6-b5f3-a6c93e104042.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/01/41040c70-d248-43a6-b5f3-a6c93e104042.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BF/B8/32db2ccb-4c11-4fe8-bb62-bee9ef1e63ff.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/B8/32db2ccb-4c11-4fe8-bb62-bee9ef1e63ff.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/74/44/1c83f629-ce7e-496d-a792-a649af7e0a0b.png",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1711733.html",
    id: "1711733",
    model: "SKUF74348",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac banane EDC en cuir véritable 6,3 pouces pour homme",
    price: "30.51",
    raw_price: "54",
    currency: "USD",
    discount: "44",
    likes_count: "93",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Brown",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6A/DD/785f3432-9107-401a-820c-a846ad655fb5.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6A/DD/785f3432-9107-401a-820c-a846ad655fb5.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4F/FF/cce00401-65cb-4aac-b50e-1d5424336807.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4F/FF/cce00401-65cb-4aac-b50e-1d5424336807.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CC/0E/f4ddd9b4-b75c-44e9-8211-14dce1ddfbc2.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3613/p-1625865.html",
    id: "1625865",
    model: "SKUE36221",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Hommes EDC cuir véritable 6,3 pouces rétro court sac de ceinture de téléphone portable",
    price: "21.49",
    raw_price: "65",
    currency: "USD",
    discount: "67",
    likes_count: "60",
    is_new: "false",
    brand: "E Ekphero",
    brand_url: "https://fr.newchic.com/e-ekphero-brand-42.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "café",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/AC/26/b31e310b-4ad5-4c57-8d51-890026c0a90b.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AC/26/b31e310b-4ad5-4c57-8d51-890026c0a90b.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6B/D5/85e26022-44ca-4990-8317-ed95819a21e1.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6B/D5/85e26022-44ca-4990-8317-ed95819a21e1.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/05/25/8c265948-ddf1-4976-95ad-07b43aeddd6d.jpg",
    url: "https://fr.newchic.com/e-ekphero-chic-wallet-3614/p-1686432.html",
    id: "1686432",
    model: "SKUF29367",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Hommes 6,3 pouces sac de ceinture en cuir véritable ",
    price: "27.99",
    raw_price: "56",
    currency: "USD",
    discount: "50",
    likes_count: "76",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9A/93/9d432fc7-852e-4456-b8e4-48dfd82ba5a0.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9A/93/9d432fc7-852e-4456-b8e4-48dfd82ba5a0.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/59/F8/ab7eec17-766f-47fb-a884-4844c13f95f6.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/59/F8/ab7eec17-766f-47fb-a884-4844c13f95f6.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B4/15/6340ac54-2447-4168-80fe-37773b805502.jpeg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1660122.html",
    id: "1660122",
    model: "SKUE87904",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Hommes EDC Vintage Sac en cuir Self-Defense Porte-monnaie Porte-monnaie",
    price: "19.99",
    raw_price: "29",
    currency: "USD",
    discount: "31",
    likes_count: "30",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Jaune",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/80/23/5053242b-997c-46a7-8a5f-3666aec6de1a.png",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/80/23/5053242b-997c-46a7-8a5f-3666aec6de1a.png",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B1/AE/5f3f1497-d1ad-468d-90a6-ba68f4919eaf.png",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B1/AE/5f3f1497-d1ad-468d-90a6-ba68f4919eaf.png",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/AB/EE/7b5f2f5f-dd66-45bc-8681-05cc18820895.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1676860.html",
    id: "1676860",
    model: "SKUF18810",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Pochette en couleur pure en cuir PU porte-carte sac de téléphone",
    price: "36.5",
    raw_price: "61.42",
    currency: "USD",
    discount: "41",
    likes_count: "9465",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Orange",
    variation_1_color: "Vert profond",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9C/84/0e0787c9-28fd-41c6-9771-c25655ef21a5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/84/0e0787c9-28fd-41c6-9771-c25655ef21a5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/31/CC/2eb1d712-0e10-45d0-87e8-459d7600162f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/31/CC/2eb1d712-0e10-45d0-87e8-459d7600162f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/03/76/a4f43c15-cba6-465d-b442-fde4d51753a1.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1339802.html",
    id: "1339802",
    model: "SKUA17464",
  },
  {
    category: "bags",
    subcategory: "Sacs à main",
    name: "Design Solid Handbag",
    price: "43.59",
    raw_price: "71.07",
    currency: "USD",
    discount: "39",
    likes_count: "1645",
    is_new: "false",
    brand: "Brenice",
    brand_url: "https://fr.newchic.com/brenice-brand-1368.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Brown",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/B6/C0/afbc5aaa-a6db-4322-a85f-538ac29519c0.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/B6/C0/afbc5aaa-a6db-4322-a85f-538ac29519c0.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/6B/06/a37f1ad6-ac74-4302-80f4-ee960fa387be.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/6B/06/a37f1ad6-ac74-4302-80f4-ee960fa387be.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/82/2B/dd91a618-cca2-4ee5-8741-a003a74fe2a2.jpg",
    url: "https://fr.newchic.com/brenice-handbags-3609/p-1523805.html",
    id: "1523805",
    model: "SKUC81807",
  },
  {
    category: "bags",
    subcategory: "Sacs à dos",
    name: "Sac à dos antivol imprimé Nylon pour femme",
    price: "19.99",
    raw_price: "45",
    currency: "USD",
    discount: "56",
    likes_count: "233",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "rouge",
    variation_1_color: "Noir",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/95/B3/463e33ab-573c-4c13-adca-6678f9105c88.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/95/B3/463e33ab-573c-4c13-adca-6678f9105c88.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/32/B1/c50e6bb2-878e-4d80-b55e-e3d54b1144c5.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/32/B1/c50e6bb2-878e-4d80-b55e-e3d54b1144c5.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F8/A1/e2e92847-c9bb-4407-a813-ef0d51711e2f.png",
    url: "https://fr.newchic.com/backpack-3624/p-1690767.html",
    id: "1690767",
    model: "SKUF37216",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Sac de ceinture de téléphone en cuir véritable de 6,3 pouces pour hommes EDC",
    price: "13.99",
    raw_price: "25",
    currency: "USD",
    discount: "44",
    likes_count: "82",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "kaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B4/93/39938a2b-59fe-41be-9942-18071b21dc9f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B4/93/39938a2b-59fe-41be-9942-18071b21dc9f.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/8B/EC/42e732f1-1f5f-481b-8d53-7190c73b38ca.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/8B/EC/42e732f1-1f5f-481b-8d53-7190c73b38ca.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0E/DC/45245018-9c7b-4d66-b8c5-5a85bc427f81.jpeg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1677276.html",
    id: "1677276",
    model: "SKUF19999",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac de ceinture pour téléphone EDC Retro 6,3 pouces pour homme",
    price: "13.99",
    raw_price: "25",
    currency: "USD",
    discount: "44",
    likes_count: "70",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0D/86/4ce1d6bb-ea14-4089-84aa-e890c1dd6ed7.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0D/86/4ce1d6bb-ea14-4089-84aa-e890c1dd6ed7.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2F/89/f25d05fc-b046-406f-8739-ced0fece09d2.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2F/89/f25d05fc-b046-406f-8739-ced0fece09d2.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1A/A9/d384de9a-4f45-4981-b41b-db1d713a1a82.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1679110.html",
    id: "1679110",
    model: "SKUF19358",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Hommes en cuir véritable 6,3 pouces EDC rétro court sac de ceinture pour téléphone portable",
    price: "25.99",
    raw_price: "59",
    currency: "USD",
    discount: "56",
    likes_count: "16",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "# 01",
    variation_1_color: "# 02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3E/B3/f4ff296a-6872-4b14-b352-1bbac1be09a4.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3E/B3/f4ff296a-6872-4b14-b352-1bbac1be09a4.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9C/D0/dfe6f18d-17f0-436e-8673-2ddd0daf9966.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/D0/dfe6f18d-17f0-436e-8673-2ddd0daf9966.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EA/2B/fdf2a3f2-a40c-43a8-a34e-00dc76778abe.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1707943.html",
    id: "1707943",
    model: "SKUF65176",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac ceinture en cuir véritable EDC pour hommes",
    price: "30.99",
    raw_price: "60",
    currency: "USD",
    discount: "48",
    likes_count: "55",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A2/FA/0d8372b1-92c6-4070-9f83-e4742cb8490c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A2/FA/0d8372b1-92c6-4070-9f83-e4742cb8490c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BF/81/83a96acd-f20e-4a7e-9a41-921daddc7976.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/81/83a96acd-f20e-4a7e-9a41-921daddc7976.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5C/25/13a60104-4ea7-4e78-813c-735a978f14fd.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3613/p-1672987.html",
    id: "1672987",
    model: "SKUE96871",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Colorful Sac à cheveux en agneau bricolage ",
    price: "33.23",
    raw_price: "70.03",
    currency: "USD",
    discount: "53",
    likes_count: "1053",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/CA/B7/5f9a8b33-f73e-4472-a1be-846178d3b338.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/CA/B7/5f9a8b33-f73e-4472-a1be-846178d3b338.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/4F/5D/67558bae-8350-4e37-86b2-00eb6fe58fc8.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/4F/5D/67558bae-8350-4e37-86b2-00eb6fe58fc8.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/FF/3B/f78552b1-7db2-4099-a0d2-964835b201c5.jpeg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1596479.html",
    id: "1596479",
    model: "SKUD94987",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Portefeuille en cuir véritable anti-vol pour homme",
    price: "24.99",
    raw_price: "53",
    currency: "USD",
    discount: "53",
    likes_count: "48",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/3C/FD/8fc55b12-e378-4c6c-93ff-a6bb2cc13efd.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/3C/FD/8fc55b12-e378-4c6c-93ff-a6bb2cc13efd.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/09/D7/d328b743-4033-495d-b6b4-8a05f3d72ee7.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/09/D7/d328b743-4033-495d-b6b4-8a05f3d72ee7.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D9/38/ddfafd98-81cb-440b-b0d0-48258f56f0b1.jpeg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1654844.html",
    id: "1654844",
    model: "SKUE64998",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac de téléphone en cuir PU",
    price: "31.05",
    raw_price: "56.99",
    currency: "USD",
    discount: "46",
    likes_count: "416",
    is_new: "false",
    brand: "Baellerry",
    brand_url: "https://fr.newchic.com/baellerry-brand-1027.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Wine Red",
    variation_1_color: "Khaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5B/99/96a2f233-3c9a-4abc-8687-cb1da5e9c8f7.JPG",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5B/99/96a2f233-3c9a-4abc-8687-cb1da5e9c8f7.JPG",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/45/00/badde08d-cc91-4601-88f7-b4c08ca135de.JPG",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/45/00/badde08d-cc91-4601-88f7-b4c08ca135de.JPG",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DE/D2/12d90a8a-4873-435c-866d-8d216354a3d5.JPG",
    url: "https://fr.newchic.com/baellerry-crossbody-bags-3610/p-1534002.html",
    id: "1534002",
    model: "SKUC69232",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Hommes en cuir véritable 6,3 pouces sac de ceinture de téléphone",
    price: "27.99",
    raw_price: "54",
    currency: "USD",
    discount: "48",
    likes_count: "39",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "#02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/37/80/889a74b2-e706-4811-99bc-18bdb05da559.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/37/80/889a74b2-e706-4811-99bc-18bdb05da559.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6C/87/ab018e12-1aa2-4012-b422-d907fd81fc59.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6C/87/ab018e12-1aa2-4012-b422-d907fd81fc59.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/C6/28a71e12-f130-452d-be54-6bd344750e98.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3613/p-1619868.html",
    id: "1619868",
    model: "SKUE23629",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Gaine de lampe de poche multifonction en cuir véritable",
    price: "20.99",
    raw_price: "45",
    currency: "USD",
    discount: "53",
    likes_count: "17",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DF/7D/0a58cd20-0ab2-400d-9c6b-675f1debed8a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DF/7D/0a58cd20-0ab2-400d-9c6b-675f1debed8a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/29/B0/aacd6559-3f1d-4f9d-8455-edaeeed52593.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/29/B0/aacd6559-3f1d-4f9d-8455-edaeeed52593.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0A/CF/02e974cd-43b3-4421-9034-799796a4bd7c.png",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1713184.html",
    id: "1713184",
    model: "SKUF76503",
  },
  {
    category: "bags",
    subcategory: "Sacs à dos",
    name: "Sac d'école solide de chargement USB multifonction décontracté",
    price: "27.99",
    raw_price: "59",
    currency: "USD",
    discount: "53",
    likes_count: "463",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Wine Red",
    variation_1_color: "Dark Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A7/76/2cf31fb6-f3b3-489c-953f-1f93f0121874.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A7/76/2cf31fb6-f3b3-489c-953f-1f93f0121874.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/48/CE/c0af939d-388b-402c-8693-d627c8dfde8b.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/48/CE/c0af939d-388b-402c-8693-d627c8dfde8b.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/17/88/dd851508-731e-488b-ac10-b7bc26d94b41.jpeg",
    url: "https://fr.newchic.com/backpack-3624/p-1663982.html",
    id: "1663982",
    model: "SKUE98924",
  },
  {
    category: "bags",
    subcategory: "Sacs à dos",
    name: "Sac à dos de voyage anti-voleur en nylon",
    price: "27.78",
    raw_price: "56.79",
    currency: "USD",
    discount: "51",
    likes_count: "4517",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "kaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CD/2F/f6c6dc72-690e-479e-9a5c-bcbcb564f0fc.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CD/2F/f6c6dc72-690e-479e-9a5c-bcbcb564f0fc.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9C/B1/cbaacf1d-d34f-4251-bfad-c410c375422e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/B1/cbaacf1d-d34f-4251-bfad-c410c375422e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C9/3C/abbd8fd2-561e-46ab-89d8-e2920fa1f360.jpg",
    url: "https://fr.newchic.com/backpack-3624/p-1345526.html",
    id: "1345526",
    model: "SKUA30569",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Femme Nylon Sac bandoulière multi-poches étanche",
    price: "26.69",
    raw_price: "51.33",
    currency: "USD",
    discount: "48",
    likes_count: "402",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Vin rouge",
    variation_1_color: "Violet",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B9/09/5b3d0842-db97-41d6-a5cf-9f847fd9f9a1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B9/09/5b3d0842-db97-41d6-a5cf-9f847fd9f9a1.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D3/73/e21518fc-c7e1-4ee4-bb26-f9b04d0e5cd7.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D3/73/e21518fc-c7e1-4ee4-bb26-f9b04d0e5cd7.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/34/2B/bbc2083f-2ef1-4c9b-9fe8-38e4072b40ff.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1378794.html",
    id: "1378794",
    model: "SKUA70841",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name:
      "Sac bandoulière solide à bandoulière en chaîne à deux couches pour femmes",
    price: "43.59",
    raw_price: "79.99",
    currency: "USD",
    discount: "46",
    likes_count: "1580",
    is_new: "false",
    brand: "Brenice",
    brand_url: "https://fr.newchic.com/brenice-brand-1368.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "gris",
    variation_1_color: "marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A6/00/d23d55b2-0b13-44c0-81c4-beba7a25a852.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A6/00/d23d55b2-0b13-44c0-81c4-beba7a25a852.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DF/14/787f1453-c5a7-4a77-95c6-a38ee0d0f72f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DF/14/787f1453-c5a7-4a77-95c6-a38ee0d0f72f.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1E/C3/71511a52-2105-46ea-9c61-775368b9328a.jpg",
    url: "https://fr.newchic.com/brenice-crossbody-bags-3610/p-1449033.html",
    id: "1449033",
    model: "SKUB65063",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac-ceinture multifonction EDC en cuir véritable",
    price: "20.99",
    raw_price: "49",
    currency: "USD",
    discount: "57",
    likes_count: "18",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Brown",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/B4/E8/1c04172b-814d-4434-b986-d55fecb8eda0.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B4/E8/1c04172b-814d-4434-b986-d55fecb8eda0.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/CC/1F/e73ba9bf-7149-4162-9cca-a88bee453997.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/CC/1F/e73ba9bf-7149-4162-9cca-a88bee453997.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0A/5A/12bad6d7-aa6f-4fa7-a73e-5ca9b5ebdb11.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1710015.html",
    id: "1710015",
    model: "SKUF71227",
  },
  {
    category: "bags",
    subcategory: "Sacs à main",
    name: "4 PCS femmes PU cuir sac à main loisirs sac à bandoulière",
    price: "20.7",
    raw_price: "28.99",
    currency: "USD",
    discount: "29",
    likes_count: "5571",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "rouge",
    variation_1_color: "Gris",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6B/79/c85d0594-fc60-4150-a4cf-3906de9283e1.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6B/79/c85d0594-fc60-4150-a4cf-3906de9283e1.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/29/7B/eaf72477-c1bd-42ca-a49c-cd39a52354cc.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/29/7B/eaf72477-c1bd-42ca-a49c-cd39a52354cc.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/C0/c11bd205-1390-49c9-b687-5145916db106.jpeg",
    url: "https://fr.newchic.com/handbags-3609/p-1367652.html",
    id: "1367652",
    model: "SKUA52875",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac à bandoulière solide pour femme à 5 fentes pour cartes",
    price: "22.99",
    raw_price: "45",
    currency: "USD",
    discount: "49",
    likes_count: "75",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "rouge",
    variation_1_color: "Violet",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/34/99/1226f189-7a9b-4aa9-acb2-7fc23ecd1ad3.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/34/99/1226f189-7a9b-4aa9-acb2-7fc23ecd1ad3.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/34/C3/f75641c2-6c23-4924-9ca8-94425225bd3d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/34/C3/f75641c2-6c23-4924-9ca8-94425225bd3d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E8/A5/09bcaf65-257c-4476-981f-76c9e74dad21.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1700202.html",
    id: "1700202",
    model: "SKUF03686",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Sac de ceinture pour lampe de poche en cuir véritable EDC pour hommes",
    price: "21.99",
    raw_price: "40",
    currency: "USD",
    discount: "45",
    likes_count: "35",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Jaune",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BC/A2/eac44791-10e1-4996-b244-6dd9320012e6.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BC/A2/eac44791-10e1-4996-b244-6dd9320012e6.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/43/3C/07863c14-3fb4-4c3b-bef9-d6f50c617330.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/43/3C/07863c14-3fb4-4c3b-bef9-d6f50c617330.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B1/03/2c9f29cd-6221-406a-b7e1-d58ee9f8d958.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1676962.html",
    id: "1676962",
    model: "SKUF19004",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac banane en cuir véritable de 6,5 pouces EDC pour hommes",
    price: "29.99",
    raw_price: "59",
    currency: "USD",
    discount: "49",
    likes_count: "37",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Jaune marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/43/C1/9c59020b-cd4f-430d-9258-d851f854840d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/43/C1/9c59020b-cd4f-430d-9258-d851f854840d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/01/8F/2f0560bb-e20e-4612-83d2-d4ab5c25e1e5.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/01/8F/2f0560bb-e20e-4612-83d2-d4ab5c25e1e5.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B2/23/f6b2aeb2-b231-4d4e-9f92-17f3fcec26c8.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1690993.html",
    id: "1690993",
    model: "SKUE96842",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Femmes loisirs sac de paille tissé sac de plage sac à bandoulière",
    price: "31.47",
    raw_price: "50",
    currency: "USD",
    discount: "37",
    likes_count: "1126",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Beige",
    variation_1_color: "chameau",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D0/E4/42a7e8e6-1f14-4bf7-9118-bbaa97fc0d14.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D0/E4/42a7e8e6-1f14-4bf7-9118-bbaa97fc0d14.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1F/B1/ae3876b7-ee9b-41e8-ab6d-127554d632b2.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1F/B1/ae3876b7-ee9b-41e8-ab6d-127554d632b2.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/49/A6/e2929d1a-aaca-4b3b-8388-11a07db82fd1.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1434340.html",
    id: "1434340",
    model: "SKUB47324",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac à bandoulière multifonction QUEENIE",
    price: "41.99",
    raw_price: "135.87",
    currency: "USD",
    discount: "69",
    likes_count: "1575",
    is_new: "false",
    brand: "Brenice",
    brand_url: "https://fr.newchic.com/brenice-brand-1368.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Brown",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/97/ED/f9c8f6df-3aaa-46fd-b1da-3b59c221cb13.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/97/ED/f9c8f6df-3aaa-46fd-b1da-3b59c221cb13.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/31/06/b95c32fa-608e-45b7-83ea-59d422a9516b.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/31/06/b95c32fa-608e-45b7-83ea-59d422a9516b.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/00/00/f8b611f1-4535-47e9-91ff-8e3f1ade8db7.JPG",
    url: "https://fr.newchic.com/brenice-crossbody-bags-3610/p-1555907.html",
    id: "1555907",
    model: "SKUD37830",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac de ceinture rétro en cuir véritable pour hommes EDC",
    price: "21.99",
    raw_price: "40",
    currency: "USD",
    discount: "45",
    likes_count: "39",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Rouge-marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/58/28/e260aaff-9466-494f-b6b6-a5526dedb14d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/58/28/e260aaff-9466-494f-b6b6-a5526dedb14d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C8/4F/7315872f-f598-4d09-ad67-9b88fb9eb784.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C8/4F/7315872f-f598-4d09-ad67-9b88fb9eb784.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B5/8D/3c102681-a8ba-4b4e-83d6-413957ef55fb.JPG",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1677279.html",
    id: "1677279",
    model: "SKUF19432",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sacs à bandoulière bohème à fleurs en cuir véritable pour femme ",
    price: "63.21",
    raw_price: "126.73",
    currency: "USD",
    discount: "50",
    likes_count: "690",
    is_new: "false",
    brand: "Socofy",
    brand_url: "https://fr.newchic.com/socofy-brand-298.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "# 01",
    variation_1_color: "# 02",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/08/52/1c426de4-9756-4373-ad52-4b8f2f2ea57d.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/08/52/1c426de4-9756-4373-ad52-4b8f2f2ea57d.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F2/AD/fd0dfd8b-76ed-482e-9f08-ce6e3326a7f7.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F2/AD/fd0dfd8b-76ed-482e-9f08-ce6e3326a7f7.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DA/63/515c0a23-97c6-486b-b2fc-f9f8a70f8fda.jpg",
    url: "https://fr.newchic.com/socofy-crossbody-bags-3610/p-1349962.html",
    id: "1349962",
    model: "SKUA34140",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac ceinture solide en cuir véritable EDC pour hommes",
    price: "18.99",
    raw_price: "36",
    currency: "USD",
    discount: "47",
    likes_count: "19",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/2C/E3/56fbd815-ab94-470c-b969-736c35f585f0.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/2C/E3/56fbd815-ab94-470c-b969-736c35f585f0.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BF/E6/8a3a64a0-838d-485c-b5ee-088d099eb608.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/E6/8a3a64a0-838d-485c-b5ee-088d099eb608.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/76/C8/5462788c-a615-4146-88ea-d350a905459f.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1689098.html",
    id: "1689098",
    model: "SKUF32139",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Rivet grande capacité sac à main en cuir PU sac à bandoulière ",
    price: "57.42",
    raw_price: "105.89",
    currency: "USD",
    discount: "46",
    likes_count: "537",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "gris",
    variation_1_color: "marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C4/13/1e221b84-e631-4317-b2c9-33e8c699a5aa.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C4/13/1e221b84-e631-4317-b2c9-33e8c699a5aa.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/4D/DA/e36a3c50-a1b7-4e97-bd66-a7a8cb483afc.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/4D/DA/e36a3c50-a1b7-4e97-bd66-a7a8cb483afc.jpeg",
    image_url: "",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1325713.html",
    id: "1325713",
    model: "SKU998416",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name: "Sac de ceinture en cuir véritable de 5,5 pouces pour hommes EDC",
    price: "19.99",
    raw_price: "38",
    currency: "USD",
    discount: "47",
    likes_count: "21",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Jaune marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E1/77/de395c34-24ea-4ede-adb2-4b8689491073.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E1/77/de395c34-24ea-4ede-adb2-4b8689491073.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E3/20/51012ebd-45bf-4cf6-8eb4-0875bf15071e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E3/20/51012ebd-45bf-4cf6-8eb4-0875bf15071e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/23/2D/dcfd7029-6a68-457a-ac8a-3e9b14c95631.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1677312.html",
    id: "1677312",
    model: "SKUF19496",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac à bandoulière floral en cuir véritable vintage",
    price: "49.04",
    raw_price: "108.65",
    currency: "USD",
    discount: "55",
    likes_count: "148",
    is_new: "false",
    brand: "Socofy-1",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "#01",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/7F/81/fe67ce5d-8dde-4cf4-84d3-8742a38830b5.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/7F/81/fe67ce5d-8dde-4cf4-84d3-8742a38830b5.jpeg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/07/8B/b05cdb06-d5b1-4612-9bae-63563a7c55e8.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1645900.html",
    id: "1645900",
    model: "SKUE39234",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Hommes EDC en cuir véritable 5,5 pouces sac de ceinture de téléphone",
    price: "28.99",
    raw_price: "59",
    currency: "USD",
    discount: "51",
    likes_count: "10",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Brown",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/07/8B/b05cdb06-d5b1-4612-9bae-63563a7c55e8.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/07/8B/b05cdb06-d5b1-4612-9bae-63563a7c55e8.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/47/4C/cd1f7ceb-7da4-46aa-a5b0-7f4073d2bead.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/47/4C/cd1f7ceb-7da4-46aa-a5b0-7f4073d2bead.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/B4/65/6c9c88ac-a82e-4498-95e9-067978af99fc.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1654253.html",
    id: "1654253",
    model: "SKUE63469",
  },
  {
    category: "bags",
    subcategory: "Portefeuilles",
    name:
      "Hommes EDC en cuir véritable 5,5 pouces sac de ceinture de téléphone",
    price: "28.99",
    raw_price: "59",
    currency: "USD",
    discount: "51",
    likes_count: "12",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Brown",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/81/4B/b3c73895-0705-4f1e-a427-a0d965323dbf.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/81/4B/b3c73895-0705-4f1e-a427-a0d965323dbf.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/06/44/d113f712-7383-4fc4-8dd5-2607ad3003db.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/06/44/d113f712-7383-4fc4-8dd5-2607ad3003db.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/52/8F/d9b56c1e-e2a4-495f-91f6-533db8adc542.jpg",
    url: "https://fr.newchic.com/chic-wallet-3614/p-1654194.html",
    id: "1654194",
    model: "SKUE63497",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sacs à bandoulière en cuir véritable pour femmes",
    price: "99.18",
    raw_price: "207.09",
    currency: "USD",
    discount: "52",
    likes_count: "734",
    is_new: "false",
    brand: "Socofy-1",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "marron",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/35/C9/5e180d06-8948-4f71-8660-29e0a39a1380.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/35/C9/5e180d06-8948-4f71-8660-29e0a39a1380.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DD/52/9d4e5d3f-737e-4d8e-a911-ed0fc71a525a.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DD/52/9d4e5d3f-737e-4d8e-a911-ed0fc71a525a.jpg",
    url: "https://fr.newchic.com/crossbody-bags-3610/p-1360916.html",
    id: "1360916",
    model: "SKUA50478",
  },
  {
    category: "bags",
    subcategory: "Sacs à dos",
    name: "Sac à bandoulière solide pour femmes",
    price: "21.24",
    raw_price: "44.74",
    currency: "USD",
    discount: "53",
    likes_count: "202",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Khaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/14/D7/03934cb4-053a-42b8-8eec-03b4fa2c6f29.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/14/D7/03934cb4-053a-42b8-8eec-03b4fa2c6f29.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E0/D7/0b2243fa-2f90-4147-9d74-c6a88ab49b17.jpeg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E0/D7/0b2243fa-2f90-4147-9d74-c6a88ab49b17.jpeg",
    url: "https://fr.newchic.com/backpack-3624/p-1646054.html",
    id: "1646054",
    model: "SKUE51182",
  },
  {
    category: "bags",
    subcategory: "Sac bandoulière",
    name: "Sac à bandoulière multifonction MANDY pour femmes",
    price: "46.86",
    raw_price: "84.89",
    currency: "USD",
    discount: "45",
    likes_count: "1964",
    is_new: "false",
    brand: "Brenice",
    brand_url: "https://fr.newchic.com/brenice-brand-1368.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Jaune",
    variation_1_color: "rouge",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/46/47/e9f77223-f3c6-4994-b88a-502715482973.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/46/47/e9f77223-f3c6-4994-b88a-502715482973.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/28/03/d0b4fbba-734d-44e5-8cf3-638b0d96b22b.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/28/03/d0b4fbba-734d-44e5-8cf3-638b0d96b22b.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/07/69/c0cba382-70f4-46bd-afc0-86c08f47f80c.JPG",
    url: "https://fr.newchic.com/brenice-crossbody-bags-3610/p-1458808.html",
    id: "1458808",
    model: "SKUB65101",
  },
  {
    category: "bags",
    subcategory: "Sacs à dos",
    name: "Sac à dos anti-vol étanche pour femmes",
    price: "37.99",
    raw_price: "65",
    currency: "USD",
    discount: "42",
    likes_count: "240",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Wine Red",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5E/07/a9c667e6-c8f9-432d-92eb-56048037954c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5E/07/a9c667e6-c8f9-432d-92eb-56048037954c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/15/8F/55a0d073-c46e-4c02-8ea2-30fc29e9e588.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/15/8F/55a0d073-c46e-4c02-8ea2-30fc29e9e588.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/94/2D/7be786ee-6daf-468d-8f17-b138c543cd11.jpg",
    url: "https://fr.newchic.com/backpack-3624/p-1660393.html",
    id: "1660393",
    model: "SKUE52404",
  },
];

export default Bags;
